/**
 * Shared helpers for Rhenium quote PDF line parsing.
 */

/**
 * @param {string} text
 * @param {RegExp} regex
 * @param {number} [group]
 * @returns {string|null}
 */
export function matchText(text, regex, group = 0) {
  const match = text.match(regex);
  return match ? match[group]?.trim() ?? null : null;
}

/**
 * @param {*} value
 * @returns {number|null}
 */
export function parseMoney(value) {
  if (value === null || value === undefined) return null;

  const cleaned = String(value)
    .replace(/,/g, '')
    .replace(/[^\d.-]/g, '');

  const number = Number(cleaned);

  return Number.isFinite(number) ? Math.round(number * 100) / 100 : null;
}

/**
 * @param {*} value
 * @returns {number|null}
 */
export function parseNumber(value) {
  if (value === null || value === undefined) return null;

  const cleaned = String(value).replace(/[^\d.-]/g, '');
  const number = Number(cleaned);

  if (!Number.isFinite(number)) return null;

  return Number.isInteger(number) ? number : number;
}
